import React, { Component } from 'react';
import PropTypes from 'prop-types';
// Redux
import { connect } from 'react-redux';

// Redux Form
import { formValueSelector } from 'redux-form';

// Redux actions
import { resendEmailVerification, refreshUserVerification } from '../../actions/manageUserVerification';

// Component
import Meetup from './Meetup';
import Verification from './Verification';
import Payment from './Payment';
import AvatarUpload from './AvatarUpload';
import Modal from './../../components_new/Modal';
import { observable, computed, action } from 'mobx';
import { observer } from 'mobx-react';
import EmailVerification from '../../components_new/verification/EmailVerification';
import ProfilePhotoVerification from '../../components_new/verification/ProfilePhotoVerification';
import Stepper from '../../components_new/Stepper';

@observer
class Booking extends Component {
  @observable modalList = [];
  @observable emailResent = false;
  @observable modalState = {
    closed: false,
  };
  state = {};
  static propTypes = {
    account: PropTypes.shape({
      userId: PropTypes.string.isRequired,
      email: PropTypes.string.isRequired,
      picture: PropTypes.string,
      displayName: PropTypes.string.isRequired,
      firstName: PropTypes.string.isRequired,
      verification: PropTypes.shape({
        isPhoneVerified: PropTypes.bool.isRequired,
      }),
    }),
    bookingData: PropTypes.shape({
      id: PropTypes.number.isRequired,
      title: PropTypes.string.isRequired,
      coverPhoto: PropTypes.number,
      user: PropTypes.shape({
        email: PropTypes.string.isRequired,
        profile: PropTypes.shape({
          profileId: PropTypes.number.isRequired,
          displayName: PropTypes.string.isRequired,
          firstName: PropTypes.string.isRequired,
          picture: PropTypes.string,
        }),
      }),
      listingRules: PropTypes.arrayOf(
        PropTypes.shape({
          description: PropTypes.string.isRequired,
        }),
      ),
      listPhotos: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.number.isRequired,
          name: PropTypes.string.isRequired,
        }),
      ),
    }),
    resendEmailVerification: PropTypes.func.isRequired,
    bookDetails: PropTypes.shape({
      startDate: PropTypes.object.isRequired,
      endDate: PropTypes.object.isRequired,
      guests: PropTypes.number.isRequired,
    }),
    serviceFees: PropTypes.object.isRequired,
    base: PropTypes.string.isRequired,
    rates: PropTypes.object.isRequired,
  };

  static defaultProps = {
    account: {
      email: null,
      displayName: null,
      firstName: null,
      picture: null,
      verification: {
        isPhoneVerified: false,
      },
    },
    bookingData: {
      title: null,
      personCapacity: 0,
      coverPhoto: null,
      city: null,
      state: null,
      country: null,
      user: {
        profile: {
          displayName: null,
          firstName: null,
          picture: null,
        },
      },
      listingRules: [],
      basePrice: 0,
      listPhotos: [],
    },
    bookDetails: {
      checkIn: null,
      checkOut: null,
      guests: 1,
    },
  };

  constructor(props) {
    super(props);
    this.state = {
      page: 'meetup',
    };
    this.nextPage = this.nextPage.bind(this);
  }

  resendEmail = async () => {
    const { client } = this.props;
    this.props.resendEmailVerification();
    this.emailResent = true;
  };

  checkEmail = async () => {
    await this.props.refreshUserVerification();
    return this.props.account.isPhoneVerified;
  };

  componentWillMount() {
    const { account } = this.props;
    if (!account.isPhoneVerified) {
      this.modalList.push({
        required: true,
        interval: 6000,
        autocheck: async () => {
          return this.checkEmail();
        },
        render: next => (
          <EmailVerification
            next={next}
            isOnboarding={false}
            userStore={this.props.account}
            resendEmail={this.resendEmail}
            emailResent={this.emailResent}
          />
        ),
      });
    }
    if (!account.picture) {
      this.modalList.push({
        required: true,
        render: next => (
          <ProfilePhotoVerification
            next={next}
            userStore={this.props.account}
            resendEmail={this.resendEmail}
            emailResent={this.emailResent}
          />
        ),
      });
    }
  }

  @computed
  get needsVerification() {
    const { account } = this.props;
    return !account.picture || !account.isPhoneVerified;
  }

  nextPage(page) {
    this.setState({ page });
  }

  @action.bound
  verificationCompleted() {
    this.modalState.closed = true;
    const v = this.needsVerification;
  }

  render() {
    const { page } = this.state;
    const { account, bookingData, promoCode } = this.props;
    const {
      bookDetails: { guests, startDate, endDate, units },
    } = this.props;
    const { serviceFees, base, rates } = this.props;

    console.log('Booking.js - units', this.props.bookDetails);

    const location = bookingData.listingAddresses.map(a => a.city + ', ' + a.state).join(' / ');

    return (
      <div>
        <Payment
          listId={bookingData.id}
          hostId={bookingData.userId}
          guestId={account.userId}
          guestEmail={account.email}
          hostDisplayName={bookingData.user.profile.firstName}
          hostPicture={bookingData.user.profile.picture}
          listTitle={bookingData.title}
          coverPhoto={bookingData.coverPhoto}
          location={location}
          listingRules={bookingData.listingRules}
          checkIn={startDate}
          checkOut={endDate}
          units={units}
          allowedPersonCapacity={bookingData.personCapacity}
          guests={guests}
          basePrice={bookingData.basePrice}
          listPhotos={bookingData.listPhotos}
          serviceFees={serviceFees}
          base={base}
          rates={rates}
          bookingType={bookingData.bookingType}
          promoCode={promoCode}
        />

        <Modal isOpen={!this.modalState.closed && this.needsVerification}>
          <Stepper steps={this.modalList} onComplete={this.verificationCompleted} />
        </Modal>
      </div>
    );
  }
}

// Decorate with connect to read form values
// const selector = formValueSelector("BookingForm"); // <-- same as form name
const paymentSelector = formValueSelector('PaymentForm'); // <-- same as form name

const mapState = state => ({
  account: state.account.data,
  bookingData: state.book.data,
  bookDetails: state.book.bookDetails,
  serviceFees: state.book.serviceFees,
  base: state.currency.base,
  rates: state.currency.rates,
  promoCode: paymentSelector(state, 'promoCode'),
});

const mapDispatch = {
  resendEmailVerification,
  refreshUserVerification,
};

export default connect(mapState, mapDispatch)(Booking);



// WEBPACK FOOTER //
// ./src/components/Booking/Booking.js